module.exports = __webpack_public_path__ + "static/media/insta9.c66c207a.jpg";